// components
import FirstSection from "../Components/Home/FirstSection";
import SecondSection from "../Components/Home/SecondSection";
import ThirdSection from "../Components/Home/ThirdSection";

const Home = () => {
  return (
    <section className="home flex-fill">
      <FirstSection />
      <div className="bg--main-stars">
        <SecondSection />
        <ThirdSection />
      </div>
    </section>
  );
};

export default Home;
